"use client";

import React from "react";
import { motion } from "framer-motion";

type SectionRevealProps = {
  children: React.ReactNode;
  className?: string;
  as?: "section" | "footer";
  "aria-labelledby"?: string;
  "aria-label"?: string;
};

export function SectionReveal({
  children,
  className = "",
  as = "section",
  "aria-labelledby": ariaLabelledBy,
  "aria-label": ariaLabel,
}: SectionRevealProps) {
  const Component = as === "footer" ? motion.footer : motion.section;
  const ariaProps =
    ariaLabelledBy != null
      ? { "aria-labelledby": ariaLabelledBy }
      : ariaLabel != null
        ? { "aria-label": ariaLabel }
        : {};

  return (
    <Component
      initial={false}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.02 }}
      className={`w-full max-w-full overflow-x-clip ${className}`}
      {...ariaProps}
    >
      {children}
    </Component>
  );
}
